<template>
  <div class="form__breaker"></div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-break"
};
</script>
